import { CustomAppConfigs } from "typings";
import { isMobile } from "utils";

const customAppConfig: CustomAppConfigs = {
  appName: "@dasa/nsw-front-minhas-consultas",
  activeWhen: (location: Location) => {
    const path = "/plataforma/consultas";

    const matches = (exclude: string[]): boolean =>
      (location.pathname.startsWith(path) ||
        location.pathname.startsWith(path + "/")) &&
      !exclude.some((path) => location.pathname.includes(path));

    if (isMobile()) {
      return matches(["coa", "agendamento", "agendadas", "pos"]);
    }

    return matches(["coa", "agendamento", "agendadas"]);
  },
};

export default customAppConfig;
